import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationTriangle, faTrash, faCopy } from '@fortawesome/free-solid-svg-icons';
import '../styles/ConfirmationModal.css';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Confirm', 
  cancelText = 'Cancel',
  type = 'default', // 'default', 'danger', 'warning'
  isLoading = false
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return faTrash;
      case 'warning':
        return faExclamationTriangle;
      case 'copy':
        return faCopy;
      default:
        return faExclamationTriangle;
    }
  };

  const getIconColor = () => {
    switch (type) {
      case 'danger':
        return '#ef4444';
      case 'warning':
        return '#f59e0b';
      case 'copy':
        return '#3b82f6';
      default:
        return '#6b7280';
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className="confirmation-modal-overlay" onClick={handleOverlayClick}>
      <div className="confirmation-modal">
        {/* Header */}
        <div className="confirmation-header">
          <div className="confirmation-icon-title">
            <div className={`confirmation-icon ${type}`}>
              <FontAwesomeIcon 
                icon={getIcon()} 
                style={{ color: getIconColor() }}
              />
            </div>
            <h2>{title}</h2>
          </div>
          <button 
            className="confirmation-close-button" 
            onClick={onClose}
            disabled={isLoading}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* Content */}
        <div className="confirmation-content">
          <p>{message}</p>
        </div>

        {/* Footer */}
        <div className="confirmation-footer">
          <button 
            className="confirmation-cancel-btn" 
            onClick={onClose}
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button 
            className={`confirmation-confirm-btn ${type}`}
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading && <div className="button-spinner"></div>}
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
